import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import IconButton from "@mui/material/IconButton";
import MoreVert from "@mui/icons-material/MoreVert";
import useActionMenu from "../../actprep-ui/hooks/ui/useActionMenu";

export default function ProgramWeekTreeItemLabel({
  programWeek,
  order,
  handleDuplicateWeekClick,
  handleSwitchWeekClick,
  handleRemoveWeekClick,
  handleEditWeekClick,
}) {
  const menuActions = [
    {
      label: "Edit",
      onClick: (event) => {
        handleEditWeekClick(event, programWeek);
      },
      disabled: !handleEditWeekClick,
    },
    {
      label: "Switch",
      onClick: (event) => {
        handleSwitchWeekClick(event, programWeek, order);
      },
      disabled: !handleSwitchWeekClick,
    },
    {
      label: "Duplicate",
      onClick: (event) => {
        handleDuplicateWeekClick(event, programWeek, order);
      },
      disabled: !handleDuplicateWeekClick,
    },
    {
      label: "Remove",
      onClick: (event) => {
        handleRemoveWeekClick(event, programWeek, order);
      },
      disabled: !handleRemoveWeekClick,
    },
  ];

  const { handleOpen: handleOpenActionMenu, ActionMenu } = useActionMenu({
    actions: menuActions,
  });

  return (
    <>
      <Stack
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Typography variant="body1" noWrap>
          {programWeek.title}
        </Typography>
        <Stack justifyContent={"center"} direction={"row"}>
          <IconButton
            size="small"
            color="primary"
            onClick={handleOpenActionMenu}
          >
            <MoreVert fontSize="small" />
          </IconButton>
        </Stack>
      </Stack>
      <ActionMenu />
    </>
  );
}
